import React, { lazy } from "react"
import { Link, useHistory } from "react-router-dom"
import AppBar from "@mui/material/AppBar"
import Toolbar from "@mui/material/Toolbar"
import Fade from "@mui/material/Fade"
import IconButton from "@mui/material/IconButton"
import MenuIcon from "@mui/icons-material/Menu"
import Button from "@mui/material/Button"
import { useTheme } from "@mui/material/styles"
import { Box } from "@mui/system"

import { USER_NAVIGATION } from "../../config"
import { getImpersonation } from "../../utils/users"

const MenuDrawer = lazy(() => import("./MenuDrawer"))
const MenuDrawerStatic = lazy(() => import("./MenuDrawerStatic"))
const SignInDynamic = lazy(() => import("./SignInDynamic"))

const Header = (props) => {
  const history = useHistory()
  const theme = useTheme()
  const [drawerOpen, setDrawerOpen] = React.useState(false)
  const [isSmall, setIsSmall] = React.useState(false)

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", () => setIsSmall(window.scrollY > 100))
    }
  }, [])

  const handleToggle = () => {
    setDrawerOpen(!drawerOpen)
  }

  const handleRouteClicked = (route) => {
    setDrawerOpen(false)
    if (route) {
      history.push(route)
    }
  }

  const impersonatedEmail = getImpersonation()?.email

  return (
    <header data-cy="main-header">
      <AppBar position="fixed" color="inherit" elevation={1}>
        {process.env.REACT_APP_ENV !== "production" && (
          <div className="sandbox-notification">
            *Using Sandbox Environment*
          </div>
        )}

        {impersonatedEmail && (
          <div className="impersonation-notification">
            You are impersonating: {impersonatedEmail}
          </div>
        )}
        <Toolbar style={{ background: theme.palette.primary.main }}>
          <Box sx={{ flex: 1 }}>
            <Fade in={isSmall} timeout={500}>
              <Link to="/">
                <img
                  align="center"
                  src="/l-assets/coastline-logo-mark.png"
                  alt="Coastline Academy Logo"
                  width="50"
                  height="34"
                  className="header-logo-icon"
                />
              </Link>
            </Fade>
            <Fade in={!isSmall} className="header-logo-container" timeout={500}>
              <Link to="/">
                <img
                  align="center"
                  src="/l-assets/coastline-logo.png"
                  alt="Coastline Academy Logo"
                  width="290"
                  height="34"
                  className="header-logo"
                />
              </Link>
            </Fade>
          </Box>
          {window.location.href.indexOf("/book-lesson/") === -1 &&
          !props.hideNav ? (
            <>
              <nav className="hide-mobile nav-links">
                {USER_NAVIGATION.filter((item) => item.showInHeader).map(
                  (item) => (
                    <Link
                      to={item.href}
                      style={{ paddingRight: 24 }}
                      key={item.href}
                    >
                      {item.label}
                    </Link>
                  ),
                )}
              </nav>
              {props.isConnected ? (
                <SignInDynamic />
              ) : (
                <Button
                  aria-label="Profile"
                  onClick={() => history.push("/profile")}
                  data-cy="header-profile-button"
                  variant="outlined"
                  size="small"
                  sx={{
                    borderColor: "accentTwo.main",
                    color: "accentTwo.main",
                  }}
                >
                  Sign In
                </Button>
              )}
              <IconButton
                aria-label="Menu"
                onClick={handleToggle}
                data-cy="header-nav-button"
                size="large"
                color="secondary"
              >
                <MenuIcon />
              </IconButton>
            </>
          ) : null}
        </Toolbar>
      </AppBar>

      {props.isConnected ? (
        <MenuDrawer
          drawerOpen={drawerOpen}
          handleRouteClicked={handleRouteClicked}
        />
      ) : (
        <MenuDrawerStatic
          drawerOpen={drawerOpen}
          handleRouteClicked={handleRouteClicked}
        />
      )}
    </header>
  )
}

export default Header
